import { FunctionComponent, SVGProps } from 'react'

export const IconBriefcase: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const filter0 = `${id}-filter0`
  const paint0 = `${id}-paint0`
  return (
    <svg
      width="26"
      height="22"
      viewBox="0 0 26 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${filter0})`}>
        <path
          d="M19.668 5.83301H6.33464C5.41416 5.83301 4.66797 6.5792 4.66797 7.49967V15.833C4.66797 16.7535 5.41416 17.4997 6.33464 17.4997H19.668C20.5884 17.4997 21.3346 16.7535 21.3346 15.833V7.49967C21.3346 6.5792 20.5884 5.83301 19.668 5.83301Z"
          fill={`url(#${paint0})`}
          shapeRendering="crispEdges"
        />
        <path
          d="M19.668 5.83301H6.33464C5.41416 5.83301 4.66797 6.5792 4.66797 7.49967V15.833C4.66797 16.7535 5.41416 17.4997 6.33464 17.4997H19.668C20.5884 17.4997 21.3346 16.7535 21.3346 15.833V7.49967C21.3346 6.5792 20.5884 5.83301 19.668 5.83301Z"
          stroke="#C8F252"
          strokeLinecap="square"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M16.3346 17.5V4.16667C16.3346 3.72464 16.159 3.30072 15.8465 2.98816C15.5339 2.67559 15.11 2.5 14.668 2.5H11.3346C10.8926 2.5 10.4687 2.67559 10.1561 2.98816C9.84356 3.30072 9.66797 3.72464 9.66797 4.16667V17.5"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id={filter0}
          x="0.167969"
          y="1.33301"
          width="25.668"
          height="20.667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2338_34422"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2338_34422"
            result="shape"
          />
        </filter>
        <linearGradient
          id={paint0}
          x1="13.0013"
          y1="5.83301"
          x2="13.0013"
          y2="17.4997"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#C8F252" stopOpacity="0" />
          <stop offset="1" stopColor="#C8F252" stopOpacity="0.6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
